// DO NOT MODIFY, this file is autogenerated by tools/build.ts
export * from 'firebase/analytics';
import { ɵzoneWrap } from '@angular/fire';
import {
  getAnalytics as _getAnalytics,
  getGoogleAnalyticsClientId as _getGoogleAnalyticsClientId,
  initializeAnalytics as _initializeAnalytics,
  isSupported as _isSupported,
  logEvent as _logEvent,
  setAnalyticsCollectionEnabled as _setAnalyticsCollectionEnabled,
  setConsent as _setConsent,
  setCurrentScreen as _setCurrentScreen,
  setDefaultEventParameters as _setDefaultEventParameters,
  setUserId as _setUserId,
  setUserProperties as _setUserProperties,
  settings as _settings
} from 'firebase/analytics';

export const getAnalytics = ɵzoneWrap(_getAnalytics, true);
export const getGoogleAnalyticsClientId = ɵzoneWrap(_getGoogleAnalyticsClientId, true);
export const initializeAnalytics = ɵzoneWrap(_initializeAnalytics, true);
export const isSupported = ɵzoneWrap(_isSupported, false);
export const logEvent = ɵzoneWrap(_logEvent, false, 2);
export const setAnalyticsCollectionEnabled = ɵzoneWrap(_setAnalyticsCollectionEnabled, true, 2);
export const setConsent = ɵzoneWrap(_setConsent, true, 2);
export const setCurrentScreen = ɵzoneWrap(_setCurrentScreen, true, 2);
export const setDefaultEventParameters = ɵzoneWrap(_setDefaultEventParameters, true, 2);
export const setUserId = ɵzoneWrap(_setUserId, true, 2);
export const setUserProperties = ɵzoneWrap(_setUserProperties, true, 2);
export const settings = ɵzoneWrap(_settings, true);
